import {
  Icon,
  IconColor,
  IconName,
  IconSize,
  textStyleUtils
} from '@focaldata/cin-ui-components'
import React from 'react'

interface Props {
  message: string
}

export const ImportValidationHint: React.FC<Props> = ({ message }) => {
  const { classes: textClasses, cx: classNames } =
    textStyleUtils.useTextStyles()

  return (
    <div>
      <Icon
        name={IconName.InfoOutlinedIcon}
        iconColor={IconColor.Error}
        size={IconSize.Medium}
      />

      <p
        className={classNames(
          textClasses.default,
          textClasses.displayInline,
          textClasses.sizeMs,
          textClasses.highlightError
        )}
        style={{ marginLeft: '8px' }}
      >
        {message}
      </p>
    </div>
  )
}
